// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__fmpq9","row":"PrintResults_row__0Afrg"};